/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { MedicoModelDto } from '../models/medico-model-dto';
import { MedicoProgramasModelDto } from '../models/medico-programas-model-dto';
import { medicosControllerAltaMedico } from '../fn/doctor-medicos/medicos-controller-alta-medico';
import { MedicosControllerAltaMedico$Params } from '../fn/doctor-medicos/medicos-controller-alta-medico';
import { medicosControllerEditarMedico } from '../fn/doctor-medicos/medicos-controller-editar-medico';
import { MedicosControllerEditarMedico$Params } from '../fn/doctor-medicos/medicos-controller-editar-medico';
import { medicosControllerEliminarMedico } from '../fn/doctor-medicos/medicos-controller-eliminar-medico';
import { MedicosControllerEliminarMedico$Params } from '../fn/doctor-medicos/medicos-controller-eliminar-medico';
import { medicosControllerObtenerMedico } from '../fn/doctor-medicos/medicos-controller-obtener-medico';
import { MedicosControllerObtenerMedico$Params } from '../fn/doctor-medicos/medicos-controller-obtener-medico';
import { medicosControllerObtenerMedicos } from '../fn/doctor-medicos/medicos-controller-obtener-medicos';
import { MedicosControllerObtenerMedicos$Params } from '../fn/doctor-medicos/medicos-controller-obtener-medicos';

@Injectable({ providedIn: 'root' })
export class DoctorMedicosService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `medicosControllerObtenerMedicos()` */
  static readonly MedicosControllerObtenerMedicosPath = '/api/medicos/obtener-medicos';

  /**
   * Obtener médicos.
   *
   * Obtiene una lista de médicos.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicosControllerObtenerMedicos()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicosControllerObtenerMedicos$Response(params?: MedicosControllerObtenerMedicos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MedicoModelDto>>> {
    return medicosControllerObtenerMedicos(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener médicos.
   *
   * Obtiene una lista de médicos.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicosControllerObtenerMedicos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicosControllerObtenerMedicos(params?: MedicosControllerObtenerMedicos$Params, context?: HttpContext): Observable<Array<MedicoModelDto>> {
    return this.medicosControllerObtenerMedicos$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MedicoModelDto>>): Array<MedicoModelDto> => r.body)
    );
  }

  /** Path part for operation `medicosControllerObtenerMedico()` */
  static readonly MedicosControllerObtenerMedicoPath = '/api/medicos/obtener-medico/{uuidMedico}';

  /**
   * Obtener información de un médico en concreto.
   *
   * Obtiene la información de un médico específico.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicosControllerObtenerMedico()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicosControllerObtenerMedico$Response(params: MedicosControllerObtenerMedico$Params, context?: HttpContext): Observable<StrictHttpResponse<MedicoProgramasModelDto>> {
    return medicosControllerObtenerMedico(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener información de un médico en concreto.
   *
   * Obtiene la información de un médico específico.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicosControllerObtenerMedico$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicosControllerObtenerMedico(params: MedicosControllerObtenerMedico$Params, context?: HttpContext): Observable<MedicoProgramasModelDto> {
    return this.medicosControllerObtenerMedico$Response(params, context).pipe(
      map((r: StrictHttpResponse<MedicoProgramasModelDto>): MedicoProgramasModelDto => r.body)
    );
  }

  /** Path part for operation `medicosControllerAltaMedico()` */
  static readonly MedicosControllerAltaMedicoPath = '/api/medicos/alta-medico';

  /**
   * Alta de un médico.
   *
   * Crea un nuevo médico en el sistema.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicosControllerAltaMedico()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  medicosControllerAltaMedico$Response(params: MedicosControllerAltaMedico$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return medicosControllerAltaMedico(this.http, this.rootUrl, params, context);
  }

  /**
   * Alta de un médico.
   *
   * Crea un nuevo médico en el sistema.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicosControllerAltaMedico$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  medicosControllerAltaMedico(params: MedicosControllerAltaMedico$Params, context?: HttpContext): Observable<void> {
    return this.medicosControllerAltaMedico$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `medicosControllerEditarMedico()` */
  static readonly MedicosControllerEditarMedicoPath = '/api/medicos/editar-medico/{uuidMedico}';

  /**
   * Edición de un médico.
   *
   * Edita un médico existente en el sistema.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicosControllerEditarMedico()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  medicosControllerEditarMedico$Response(params: MedicosControllerEditarMedico$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return medicosControllerEditarMedico(this.http, this.rootUrl, params, context);
  }

  /**
   * Edición de un médico.
   *
   * Edita un médico existente en el sistema.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicosControllerEditarMedico$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  medicosControllerEditarMedico(params: MedicosControllerEditarMedico$Params, context?: HttpContext): Observable<void> {
    return this.medicosControllerEditarMedico$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `medicosControllerEliminarMedico()` */
  static readonly MedicosControllerEliminarMedicoPath = '/api/medicos/eliminar-medico/{uuidMedico}';

  /**
   * Eliminación de un médico.
   *
   * Elimina un médico existente en el sistema.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicosControllerEliminarMedico()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicosControllerEliminarMedico$Response(params: MedicosControllerEliminarMedico$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return medicosControllerEliminarMedico(this.http, this.rootUrl, params, context);
  }

  /**
   * Eliminación de un médico.
   *
   * Elimina un médico existente en el sistema.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicosControllerEliminarMedico$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicosControllerEliminarMedico(params: MedicosControllerEliminarMedico$Params, context?: HttpContext): Observable<void> {
    return this.medicosControllerEliminarMedico$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
